import { gsap } from 'gsap'

export async function delay(seconds) {

  return new Promise( (resolve) => {
    gsap.delayedCall(seconds, resolve)
  })
}

export async function delayCallBack(seconds, cb) {
  return new Promise((resolve) => {
    gsap.delayedCall(seconds, () => {
      if (cb) {
        cb()
      }
      resolve()
    })
  })
}
